module.exports = __webpack_public_path__ + "static/media/global.49dd02ee.svg";